import { render, staticRenderFns } from "./Tier2.vue?vue&type=template&id=5c658208"
import script from "./Tier2.vue?vue&type=script&lang=ts"
export * from "./Tier2.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c658208')) {
      api.createRecord('5c658208', component.options)
    } else {
      api.reload('5c658208', component.options)
    }
    module.hot.accept("./Tier2.vue?vue&type=template&id=5c658208", function () {
      api.rerender('5c658208', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/upgrades/Tier2.vue"
export default component.exports